import React, { useEffect } from 'react';

/**
 * HeroSlider - Revolution Slider with exact original content
 * Preserves exact text and styling from original
 */
function HeroSlider() {
  useEffect(() => {
    // Initialize Revolution Slider after component mount
    const initSlider = () => {
      if (window.jQuery && window.jQuery('#rev_slider_19_1').revolution) {
        window.jQuery('#rev_slider_19_1').show().revolution({
          sliderType: 'standard',
          jsFileLocation: '/rs-plugin/js/',
          sliderLayout: 'fullscreen',
          dottedOverlay: 'none',
          delay: 9000,
          navigation: {
            keyboardNavigation: 'off',
            keyboard_direction: 'horizontal',
            mouseScrollNavigation: 'off',
            onHoverStop: 'off',
            touch: {
              touchenabled: 'on',
              swipe_threshold: 75,
              swipe_min_touches: 1,
              swipe_direction: 'horizontal',
              drag_block_vertical: false
            }
          },
          responsiveLevels: [1240, 1024, 778, 480],
          visibilityLevels: [1240, 1024, 778, 480],
          gridwidth: [1240, 1024, 778, 480],
          gridheight: [868, 768, 960, 720],
          lazyType: 'none',
          shadow: 0,
          spinner: 'off',
          stopLoop: 'off',
          stopAfterLoops: -1,
          stopAtSlide: -1,
          shuffle: 'off',
          autoHeight: 'off',
          fullScreenAutoWidth: 'off',
          fullScreenAlignForce: 'off',
          fullScreenOffsetContainer: '',
          fullScreenOffset: '',
          disableProgressBar: 'on',
          hideThumbsOnMobile: 'off',
          hideSliderAtLimit: 0,
          hideCaptionAtLimit: 0,
          hideAllCaptionAtLilmit: 0,
          debugMode: false,
          fallbacks: {
            simplifyAll: 'off',
            nextSlideOnWindowFocus: 'off',
            disableFocusListener: false,
          }
        });
      }
    };

    // Delay initialization to ensure DOM is ready
    setTimeout(initSlider, 100);
  }, []);

  return (
    <section id="home" className="p-0 onepage-slide single-slide">
      <h2 className="d-none">hidden</h2>
      <div 
        id="rev_slider_19_1_wrapper" 
        className="rev_slider_wrapper fullscreen-container" 
        data-alias="wexim_slider_01" 
        data-source="gallery" 
        style={{ background: 'transparent', padding: '0px' }}
      >
        {/* START REVOLUTION SLIDER 5.4.8.1 fullscreen mode */}
        <div id="rev_slider_19_1" className="rev_slider fullscreenbanner" style={{ display: 'none' }} data-version="5.4.8.1">
          <ul>
            {/* SLIDE */}
            <li 
              data-index="rs-1" 
              data-transition="crossfade" 
              data-slotamount="default" 
              data-hideafterloop="0" 
              data-hideslideonmobile="off" 
              data-easein="default" 
              data-easeout="default" 
              data-masterspeed="default" 
              data-thumb="images/slide-img1.jpg" 
              data-rotate="0" 
              data-description=""
            >
              {/* MAIN IMAGE */}
              <img 
                src="images/DataFlex_bkgd06.jpeg" 
                alt="" 
                data-bgposition="center center" 
                data-bgfit="cover" 
                data-bgparallax="10" 
                data-bgrepeat="no-repeat" 
                className="rev-slidebg" 
                data-no-retina 
              />
              {/* LAYERS */}

              {/* Overlay */}
              <div className="bg-overlay opacity-3 z-index-1"></div>

              {/* layer nr. 1 */}
              <div 
                className="tp-caption NotGeneric-SubTitle tp-resizeme text-gray"
                data-x="['left','left','left','left']" 
                data-hoffset="['45','45','20','15']"
                data-y="['middle','middle','middle','middle']" 
                data-voffset="['-35','-35','-35','-20']"
                data-fontsize="['44','44','35','30']"
                data-lineheight="['44','44','35','30']"
                data-width="none"
                data-height="none"
                data-whitespace="nowrap"
                data-type="text"
                data-responsive_offset="on"
                data-frames='[{"from":"y:50px;opacity:0;","speed":1000,"to":"o:1;","delay":600,"ease":"Power4.easeInOut"},{"delay":"wait","speed":1000,"to":"y:[175%];","mask":"x:inherit;y:inherit;s:inherit;e:inherit;","ease":"Power2.easeInOut"}]'
                data-textAlign="['left','left','left','left']"
                style={{ zIndex: 8, whiteSpace: 'nowrap', fontFamily: 'Poppins, sans-serif !important', fontWeight: 500 }}
                dangerouslySetInnerHTML={{ __html: 'Flexible Load. <br> Public Power. <br> Grid health prioritized.' }}
              />
              
              {/* layer nr. 2 */}
              <div 
                className="tp-caption NotGeneric-Title tp-resizeme font-weight-100"
                data-x="['left','left','left','left']" 
                data-hoffset="['45','45','20','15']"
                data-y="['middle','middle','middle','middle']" 
                data-voffset="['55','55','55','55']"
                data-fontsize="['20','20','18','14']"
                data-lineheight="['25','25','25','25']"
                data-width="none"
                data-height="none"
                data-whitespace="nowrap"
                data-type="text"
                data-responsive_offset="on"
                data-frames='[{"from":"y:50px;opacity:0;","speed":1000,"to":"o:1;","delay":800,"ease":"Power4.easeInOut"},{"delay":"wait","speed":1000,"to":"y:[175%];","mask":"x:inherit;y:inherit;s:inherit;e:inherit;","ease":"Power2.easeInOut"}]'
                data-textAlign="['left','left','left','left']"
                style={{ zIndex: 99, whiteSpace: 'nowrap' }}
              >
                Utility-Controlled datacenter compute as grid stablizing assets.
              </div>

              {/* layer nr. 3 */}
              <div 
                className="tp-caption z-index-5"
                data-x="['left','left','left','left']" 
                data-hoffset="['45','45','20','15']"
                data-y="['middle','middle','middle','middle']" 
                data-voffset="['135','135','135','135']"
                data-fontsize="['18','18','18','18']"
                data-lineheight="['18','18','18','18']"
                data-width="none"
                data-height="none"
                data-whitespace="nowrap"
                data-type="text"
                data-responsive_offset="on"
                data-frames='[{"from":"y:50px;opacity:0;","speed":1000,"to":"o:1;","delay":1000,"ease":"Power4.easeInOut"},{"delay":"wait","speed":1000,"to":"y:[175%];","mask":"x:inherit;y:inherit;s:inherit;e:inherit;","ease":"Power2.easeInOut"},{"frame":"hover","speed":"300","ease":"Power1.easeInOut","to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgba(255, 255, 255, 1.00);bc:rgba(255, 255, 255, 1.00);bw:2px 2px 2px 2px;"}]'
                data-textAlign="['center','center','center','center']"
                style={{ zIndex: 7, whiteSpace: 'nowrap', fontFamily: 'Poppins, sans-serif !important', fontWeight: 100 }}
              >
                <a href="#about" className="btn btn-gradient btn-rounded btn-large mr-2">Explore</a>
              </div>
            </li>
          </ul>
        </div>
        {/* END REVOLUTION SLIDER */}
      </div>
    </section>
  );
}

export default HeroSlider;